<script setup lang="ts">
import { computed, markRaw, ref } from 'vue'

import IconSettingForm from '@/components/atoms/icons/IconSettingForm.vue'
import IconSettingLayout from '@/components/atoms/icons/IconSettingLayout.vue'
import SettingText from '@/components/atoms/SettingText.vue'
import SettingWidth from '@/components/atoms/SettingWidth.vue'
import EditorSidebarLayout from '@/components/layouts/EditorSidebarLayout.vue'
import SettingsLayout from '@/components/layouts/SettingsLayout.vue'
import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const elementForEdit = computed(() => betaStore.elementForEdit)
const settings = ref([
    { id: 1, name: 'form', icon: markRaw(IconSettingForm) },
    { id: 2, name: 'layout', icon: markRaw(IconSettingLayout) },
])

const ensureFrameContent = () => {
    if (!elementForEdit.value) return

    elementForEdit.value.frameContent = {
        ...(elementForEdit.value.frameContent ?? {}),
    }
}

const onChangeWidth = (event: any) => {
    if (!elementForEdit.value) return

    if (event.target === 'desktop') elementForEdit.value.grid = event.value
    if (event.target === 'mobile') elementForEdit.value.gridMobile = event.value

    betaStore.updateElementForEdit()
}

const onChangeFrameContent = (key: 'submit' | 'message' | 'redirect', event: any) => {
    if (!elementForEdit.value) return
    ensureFrameContent()

    elementForEdit.value.frameContent = {
        ...elementForEdit.value.frameContent,
        [key]: event.value,
    }

    betaStore.updateElementForEdit()
}
</script>

<template>
    <editor-sidebar-layout v-if="elementForEdit" :settings="settings">
        <template #form>
            <settings-layout name="Configurações do Formulário" :default-open="true">
                <setting-text
                    label="Texto do botão"
                    placeholder="Ex: Enviar"
                    :value="elementForEdit.frameContent?.submit ?? null"
                    @change="(event: any) => onChangeFrameContent('submit', event)"
                />

                <setting-text
                    label="Mensagem após o envio"
                    placeholder="Ex: Mensagem enviada com sucesso"
                    :value="elementForEdit.frameContent?.message ?? null"
                    @change="(event: any) => onChangeFrameContent('message', event)"
                />

                <div>
                    <setting-text
                        label="Url de redirecionamento"
                        placeholder="Ex: https://www.google.com.br"
                        :value="elementForEdit.frameContent?.redirect ?? null"
                        @change="(event: any) => onChangeFrameContent('redirect', event)"
                    />

                    <span class="text-[10px] font-semibold text-[#060606] opacity-50">
                        (caso em branco, vai continuar na mesma página)
                    </span>
                </div>
            </settings-layout>
        </template>

        <template #layout>
            <settings-layout name="Layout do Formulário" :default-open="true">
                <setting-width
                    label="Largura"
                    :value="elementForEdit.grid"
                    :value-mobile="elementForEdit.gridMobile"
                    :values-permission-desktop="[4, 6, 12]"
                    :values-permission-mobile="[4, 6, 12]"
                    @change="onChangeWidth"
                />
            </settings-layout>
        </template>
    </editor-sidebar-layout>
</template>
